import React from "react";
import { Button, Col, Container, Image, Row } from "react-bootstrap";
import { brandName } from "../Constants/content";
import {
  primaryColor,
  secondaryColor,
  textDarkColor,
} from "../Constants/Colors";
import star from "../Assets/Images/Works/Mahalakshmi/start.png";
import googlePlayIcon from "../Assets/Images/Works/Mahalakshmi/icons/icons8-google-play-16.png";
import chain from "../Assets/Images/Works/Mahalakshmi/icons/chain.png";
import { FaApple } from "react-icons/fa";
import GetInTouch from "./GetInTouch";

const WorksComponent = ({ data }) => {
  if (!data) return null;

  const {
    title,
    tagline,
    subtitle,
    headerButtons = [],
    overview_description,
    overview_goals_title,
    overview_summary,
    overviewGoals = [],
    visual_mobile1,
    visual_mobile2,
    visual_laptop,
    client_goals_title,
    client_goals_image,
    client_goals_list = data.clientGoalsList || [],
    key_challenges_title,
    key_challenges_image,
    key_challenges_list = data.keyChallengesList || [],
    solution_title,
    solution_description,
    solutionItems = [],
    results_title,
    results_description,
    resultsStats = [],
    website,
    websiteUrl,
    showDownloads,
    portalText,
    previewImage,
    ctaDescription,
    playStoreUrl,
    appStoreUrl,
    top_bg,
    btm_bg,
  } = data;

  // Transform complex data structures for the component
  const overview = {
    title: "Project Overview",
    description: overview_description,
    goalsTitle: overview_goals_title,
    goalsList: overviewGoals.map((g) => (typeof g === "string" ? g : g.text)),
    summary: overview_summary,
  };

  const visuals = {
    mobile1: visual_mobile1,
    mobile2: visual_mobile2,
    laptop: visual_laptop,
  };

  const clientGoals = {
    title: client_goals_title,
    image: client_goals_image,
    list: client_goals_list,
  };

  const keyChallenges = {
    title: key_challenges_title,
    image: key_challenges_image,
    list: key_challenges_list,
  };

  const solution = {
    title: solution_title,
    description: solution_description,
    items: solutionItems,
  };

  const results = {
    title: results_title,
    description: results_description,
    stats: resultsStats,
  };

  const projectLinks = {
    website,
    websiteUrl,
    showDownloads,
    portalText,
    previewImage,
    playStoreUrl,
    appStoreUrl,
  };

  return (
    <Container className="mt-2">
      {/* Header Section */}
      <div className="text-center position-relative works-page-header-bg">
        <Image src={top_bg} className="top-bg-img" />
        <Button
          variant="primary"
          style={{
            backgroundColor: "#007bff",
            border: "none",
            borderRadius: "20px",
            padding: "5px 20px",
            fontSize: "14px",
          }}
        >
          Works
        </Button>
        <h2 className="my-3" style={{ color: primaryColor }}>
          {title}
        </h2>
        <p>{tagline}</p>
        <h5 className="my-2">
          {subtitle} | Designed & Built by{" "}
          <span
            style={{
              background: `linear-gradient(90deg, ${primaryColor}, ${secondaryColor})`,
              WebkitBackgroundClip: "text",
              WebkitTextFillColor: "transparent",
              fontWeight: "bold",
            }}
          >
            {brandName}
          </span>
        </h5>
        {headerButtons.length > 0 && (
          <div className="d-flex justify-content-center gap-4 mt-4">
            {headerButtons.map((btn, index) => (
              <Button
                key={index}
                variant="outline-dark"
                className="rounded-pill"
                href={btn.link}
                target="_blank"
              >
                {btn.text}
              </Button>
            ))}
          </div>
        )}
        <Image className="bottom-bg-img" src={btm_bg} />
      </div>

      {/* Project Overview */}
      {overview && (
        <Row>
          <Col md={11} className="mx-auto my-4">
            <h2 className="text-center" style={{ color: primaryColor }}>
              {overview.title || "Project Overview"}
            </h2>
            <p
              className="text-justify text-center"
              style={{ lineHeight: "2", fontSize: "17px" }}
            >
              {overview.description}
            </p>
          </Col>
          <Col>
            <div className="text-center">
              <h4
                className="p-1 d-inline-block fst-italic"
                style={{
                  color: primaryColor,
                  backgroundColor: " #e2f2f9ff",
                  textShadow: "1px 1px 3px rgba(0, 0, 0, 0.3)",
                  textTransform: "capitalize",
                }}
              >
                {overview.goalsTitle}
              </h4>
            </div>
            <ul className="list-unstyled d-flex flex-lg-row flex-column gap-3 justify-content-center my-4 ms-5 ms-lg-0">
              {overview.goalsList?.map((goal, index) => (
                <li key={index}>{goal}</li>
              ))}
            </ul>
            <p className="text-center">{overview.summary}</p>
          </Col>
        </Row>
      )}

      {/* Visuals Section */}
      {visuals && (
        <Row className="d-flex justify-content-center align-items-center my-5">
          <Col xs={3} className="position-relative">
            <Image
              src={star}
              className="star-bg-img"
              style={{ top: "0%", left: "0%", width: "auto", zIndex: "-1" }}
            />
            <Image
              src={star}
              className="star-bg-img"
              style={{ bottom: "0%", left: "10%", width: "auto", zIndex: "-1" }}
            />
            <Image
              src={star}
              className="star-bg-img"
              style={{ top: "0%", right: "0%", width: "auto", zIndex: "-1" }}
            />
            <Image src={visuals.mobile2} fluid />
          </Col>
          <Col xs={6} className="position-relative">
            <Image
              src={star}
              className="star-bg-img"
              style={{ top: "0%", right: "0%", width: "auto", zIndex: "-1" }}
            />
            <Image src={visuals.laptop} fluid />
          </Col>
          <Col xs={3} className="position-relative">
            <Image
              src={star}
              className="star-bg-img"
              style={{ bottom: "0%", left: "20%", width: "auto", zIndex: "-1" }}
            />
            <Image
              src={star}
              className="star-bg-img"
              style={{ top: "0%", right: "0%", width: "auto", zIndex: "-1" }}
            />
            <Image src={visuals.mobile1} fluid />
          </Col>
        </Row>
      )}

      {/* Client Goals & Challenges */}
      <Row>
        {clientGoals && (
          <>
            <Col
              xs={12}
              md={7}
              lg={7}
              xl={6}
              className="px-3 px-lg-5 my-2 my-md-5"
            >
              <Button
                className="rounded-pill"
                style={{ backgroundColor: primaryColor, border: "none" }}
              >
                {clientGoals.title || "Client Goals"}
              </Button>
              <ul className="list-unstyled">
                {clientGoals.list?.map((goal, index) => (
                  <li
                    key={index}
                    style={{
                      display: "flex",
                      alignItems: "center",
                      gap: "8px",
                      borderLeft: `5px solid ${primaryColor}`,
                      borderRight: "5px solid rgb(201, 203, 204)",
                      borderRadius: "10px",
                      boxShadow: "0 -2px 4px rgba(0, 0, 0, 0.2)",
                    }}
                    className="p-1 p-lg-2 mt-2 mt-lg-3"
                  >
                    <span
                      style={{
                        background:
                          "linear-gradient(to left, #1e3b8a, #4fa8f1)",
                        WebkitMaskImage:
                          "url('data:image/svg+xml;utf8,<svg xmlns=%22http://www.w3.org/2000/svg%22 fill=%22black%22 viewBox=%220 0 512 512%22><path d=%22M504 256c0 136.967-111.033 248-248 248S8 392.967 8 256 119.033 8 256 8s248 111.033 248 248zM227.314 387.314l184-184c6.248-6.248 6.248-16.379 0-22.627l-22.627-22.627c-6.248-6.248-16.379-6.248-22.627 0L216 308.373l-70.059-70.059c-6.248-6.248-16.379-6.248-22.627 0l-22.627 22.627c-6.248 6.248-6.248 16.379 0 22.627l104 104c6.248 6.248 16.379 6.248 22.627 0z%22/></svg>')",
                        WebkitMaskRepeat: "no-repeat",
                        WebkitMaskSize: "cover",
                        display: "inline-block",
                        width: "20px",
                        height: "20px",
                      }}
                      className="pe-3"
                    ></span>
                    {goal.title}
                  </li>
                ))}
              </ul>
            </Col>
            <Col xs={9} md={5} lg={5} xl={4} className="m-auto">
              <Image src={clientGoals.image} fluid />
            </Col>
          </>
        )}
      </Row>

      {keyChallenges && (
        <Row className="mb-5 mt-3 mt-md-0">
          <Col
            xs={9}
            md={5}
            lg={5}
            xl={4}
            className="m-auto d-none d-md-flex justify-content-center"
          >
            <Image src={keyChallenges.image} fluid />
          </Col>
          <Col xs={12} md={7} lg={7} xl={6} className="px-3 px-lg-5">
            <Button
              className="rounded-pill"
              style={{ backgroundColor: primaryColor, border: "none" }}
            >
              {keyChallenges.title || "Key Challenges"}
            </Button>
            <ul className="list-unstyled">
              {keyChallenges.list?.map((challenge, index) => (
                <li
                  key={index}
                  style={{
                    display: "flex",
                    alignItems: "center",
                    gap: "8px",
                    borderLeft: `5px solid ${primaryColor}`,
                    borderRight: "5px solid rgb(201, 203, 204)",
                    borderRadius: "10px",
                    boxShadow: "0 -2px 4px rgba(0, 0, 0, 0.2)",
                  }}
                  className="p-1 p-lg-2 mt-2 mt-lg-3"
                >
                  <span
                    style={{
                      background: "linear-gradient(to left, #1e3b8a, #4fa8f1)",
                      WebkitMaskImage:
                        "url('data:image/svg+xml;utf8,<svg xmlns=%22http://www.w3.org/2000/svg%22 fill=%22black%22 viewBox=%220 0 512 512%22><path d=%22M504 256c0 136.967-111.033 248-248 248S8 392.967 8 256 119.033 8 256 8s248 111.033 248 248zM227.314 387.314l184-184c6.248-6.248 6.248-16.379 0-22.627l-22.627-22.627c-6.248-6.248-16.379-6.248-22.627 0L216 308.373l-70.059-70.059c-6.248-6.248-16.379-6.248-22.627 0l-22.627 22.627c-6.248 6.248-6.248 16.379 0 22.627l104 104c6.248 6.248 16.379 6.248 22.627 0z%22/></svg>')",
                      WebkitMaskRepeat: "no-repeat",
                      WebkitMaskSize: "cover",
                      display: "inline-block",
                      width: "20px",
                      height: "20px",
                    }}
                    className="pe-3"
                  ></span>
                  {challenge.title}
                </li>
              ))}
            </ul>
          </Col>
          <Col
            xs={9}
            md={5}
            lg={5}
            xl={4}
            className="m-auto d-flex justify-content-center d-md-none"
          >
            <Image src={keyChallenges.image} fluid />
          </Col>
        </Row>
      )}

      {/* Solutions */}
      {solution && (
        <Row>
          <h2 className="text-center" style={{ color: primaryColor }}>
            {solution.title || "Our Solution"}
          </h2>
          <p className="text-center">{solution.description}</p>
          <Col>
            {solution.items?.map((item, index) => (
              <Row key={index} className="my-4">
                <Col xs={12} md={11} lg={10} className="mx-auto">
                  <Row
                    className="d-flex justify-content-center align-items-center mx-auto"
                    style={{ borderBottom: `1px solid ${primaryColor}` }}
                  >
                    <Col xs={2} sm={1}>
                      <Image src={item.icon} />
                    </Col>
                    <Col xs={9} sm={7} md={2}>
                      <h5
                        style={{ color: primaryColor }}
                        className="d-none d-lg-flex"
                      >
                        {item.title}
                      </h5>
                      <h6
                        style={{ color: primaryColor }}
                        className="d-flex d-lg-none"
                      >
                        {item.title}
                      </h6>
                    </Col>
                    <Col xs={12} sm={12} md={8} lg={9}>
                      <p
                        className="text-justify ms-3"
                        style={{ fontSize: "14px" }}
                      >
                        {item.description}
                      </p>
                    </Col>
                  </Row>
                </Col>
              </Row>
            ))}
          </Col>
        </Row>
      )}

      {/* Results */}
      {results && (
        <div className="mt-5">
          <h2 style={{ color: primaryColor }} className="text-center">
            {results.title || "The Results"}
          </h2>
          <p className="text-center">{results.description}</p>
          <Row className="results-stats mx-auto my-5">
            {results.stats?.map((stat, index) => (
              <Col
                key={index}
                xs={4}
                className="text-center py-4"
                style={{
                  borderRight:
                    (index + 1) % 3 !== 0
                      ? `2px solid ${primaryColor}`
                      : "none",
                  borderBottom:
                    index <
                    results.stats.length -
                      (results.stats.length % 3 === 0
                        ? 3
                        : results.stats.length % 3)
                      ? `2px solid ${primaryColor}`
                      : "none",
                }}
              >
                <h2 style={{ color: "#009fe3", fontWeight: "bold" }}>
                  {stat.value}
                </h2>
                <p className="text-muted mb-0">{stat.label}</p>
              </Col>
            ))}
          </Row>
        </div>
      )}

      {/* Project Links Section */}
      {projectLinks && (
        <Container className="my-4">
          <Row
            className="align-items-center justify-content-between"
            style={{
              backgroundImage: "linear-gradient(135deg, #014F6F, #0297D5)",
              borderRadius: "12px",
              border: "6px solid #ade2f9ff",
            }}
          >
            <Col
              md={6}
              lg={5}
              className="d-flex flex-column gap-lg-3 gap-1 py-2 py-lg-0"
            >
              <h4 className="fw-bold text-light">
                <Image width={20} height={20} src={chain} />
                &nbsp; Project Links
              </h4>
              <p className="text-light">
                <strong>Website:</strong>{" "}
                <a
                  href={projectLinks.websiteUrl}
                  target="_blank"
                  rel="noreferrer"
                  className="text-light"
                >
                  {projectLinks.website}
                </a>
              </p>
              {projectLinks.showDownloads !== false &&
                (projectLinks.playStoreUrl || projectLinks.appStoreUrl) && (
                  <>
                    <p className="text-light">
                      <strong>Mobile App:</strong> Available Now On
                    </p>
                    <div className="d-flex gap-3">
                      {projectLinks.playStoreUrl && (
                        <Button
                          style={{
                            background:
                              "linear-gradient(to top, #025191ff, #13abecff)",
                            color: "#fff",
                            fontSize: "12px",
                          }}
                          className="d-flex align-items-center gap-1 gap-md-2 rounded-3 px-2 px-md-3"
                          href={projectLinks.playStoreUrl}
                          target="_blank"
                        >
                          <Image src={googlePlayIcon} /> Download Now
                        </Button>
                      )}
                      {projectLinks.appStoreUrl && (
                        <Button
                          style={{
                            background:
                              "linear-gradient(to top, #025191ff, #13abecff)",
                            color: "#fff",
                            fontSize: "12px",
                          }}
                          className="d-flex align-items-center gap-1 gap-md-2 rounded-3 px-2 px-md-3"
                          href={projectLinks.appStoreUrl}
                          target="_blank"
                        >
                          <FaApple /> Download Now
                        </Button>
                      )}
                    </div>
                  </>
                )}
              <p className="text-light mb-0">{projectLinks.portalText}</p>
            </Col>
            <Col md={6} lg={7} className="p-0 m-0">
              <Image
                src={projectLinks.previewImage}
                alt="Project Preview"
                className="rounded"
                fluid
              />
            </Col>
          </Row>
        </Container>
      )}

      <GetInTouch
        radius={60}
        description={
          ctaDescription ||
          "Leverage our expertise to transform your digital presence and elevate your brand."
        }
        bgColor="light"
        borderColor={secondaryColor}
        textColor={textDarkColor}
        subTextColor={primaryColor}
        circleTextColor={textDarkColor}
        descriptionColor={textDarkColor}
      />
    </Container>
  );
};

export default WorksComponent;
